import { useState } from 'react'
import CorsiService from '../services/CorsiService/CorsiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';
import { useNavigate } from 'react-router';

const useCorsi = () => {
    const navigate = useNavigate();
    const {REACT_APP_REST_ENDPOINT, REACT_APP_REST_DOMAIN} = process.env;

    const [modalState, setModalState] = useState({
      showModalUpdateStateCorso: false,
      showModalAddDocumentCorsi: false,
      showModalDocumentByIdCorso: false,
      showModalDeleteDocumentCorsi: false,
      showModalAddUserToCourse: false,
    });

    const [loadingState, setLoadingState] = useState({
      isLoadingCorsi: false,
      isLoadingCorsiByIdUtente: false,
      isLoadingCorsoDeleting: false,
      isLoadingCorsoCreating: false,
      isLoadingCorsoUpdate: false,
      isLoadingUpdateStateCorso: false,
      isLoadingUploadImgCorsoCreating: false,
      isLoadingContenutiByIdCorso: false,
      isLoadingCorsoById: false,
      isLoadingCorsiByParams: false,
      isLoadingCorsiAddDocument: false,
      isLoadingCorsiDeleteDocument: false,
      isLoadingFindDocumentiByIdCorso: false,
    });

    const getAllCorsi = async () => {
      setLoadingState({ ...loadingState, isLoadingCorsi: true });
        try {
          let response = await CorsiService.getAllCorsi();
          if (response.ok) {
            const corsi = await response.json();
            const activeCourses = corsi?.filter(corso => corso.attivo == '1');
            return activeCourses;
          } 
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsi: false });
        }
      };


      const createCorso = async (data, imgBlob) => {
        setLoadingState({ ...loadingState, isLoadingCorsoCreating: true });
        try {
          let response = await CorsiService.createCorso(data);
          if (response?.id_corso) {
            if (imgBlob) {
              const formData = new FormData();
              formData.append('id_corso', response.id_corso);
              formData.append('file', imgBlob);
              const token = localStorage.getItem('token');
              setLoadingState({ ...loadingState, isLoadingUploadImgCorsoCreating: true });
              try {
                await fetch(`${REACT_APP_REST_ENDPOINT}/corsi/uploadImage`, {
                  method: 'POST',
                  headers: {
                    "Authorization": `Bearer ${token}`,
                  },
                  body: formData,
                }).then(res => res.json())
              } catch (error) {
                handleError(error)
              } 
            } else {
              setLoadingState({ ...loadingState, isLoadingCorsoCreating: false});
            }
            return response;
          }
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsoCreating: false});
        }
      }

      const updateCorso = async (data, imgBlob) => {
        setLoadingState({ ...loadingState, isLoadingCorsoUpdate: true });
        try {
          let response = await CorsiService.updateCorso(data);
          if (response) {
            if (imgBlob) {
              const formData = new FormData();
              formData.append('id_corso', data?.id_corso);
              formData.append('file', imgBlob);
              const token = localStorage.getItem('token');
              setLoadingState({ ...loadingState, isLoadingUploadImgCorsoCreating: true });
                await fetch(`${REACT_APP_REST_ENDPOINT}/corsi/uploadImage`, {
                  method: 'POST',
                  headers: {
                    "Authorization": `Bearer ${token}`,
                  },
                  body: formData,
                }).then(res => res.json())
              } else {
                setLoadingState({ ...loadingState, isLoadingCorsoUpdate: false});
              }
              return response;
            }
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingUploadImgCorsoCreating: false });
            setLoadingState({ ...loadingState, isLoadingCorsoUpdate: false});
          }
        }
      

      const deleteCorso = async (id) => {
        setLoadingState({ ...loadingState, isLoadingCorsoDeleting: true });
        try {
          let response = await CorsiService.deleteCorso(id);
          const res = await response.json();
          if(res){
            alertService.success("Corso eliminato con successo", {autoClose: true});
            return res;
          }
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsoDeleting: false });
        }
      }

      const findDocumentiByIdCorso = async (data) => {
        setLoadingState({ ...loadingState, isLoadingFindDocumentiByIdCorso: true });
        try {
          let response = await CorsiService.findDocumentiByIdCorso(data);
          return response;
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingFindDocumentiByIdCorso: false });
        }
      }

      const findCorsiByIdUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiByIdUtente: true });
        try {
          let response = await CorsiService.findCorsiByIdUtente(data);
          return response
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiByIdUtente: false });
        }
      }

      const findCorsoById = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsoById: true });
        try {
          let response = await CorsiService.findCorsoById(data);
          return response
        } catch (err) {
          if(err?.error?.code === "NOT_FOUND"){
            navigate("/corsi")
          }
          handleError(err, {
            NOT_FOUND: "Corso non trovato"
          })
          
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsoById: false });
        }
      }

      const findContenutiByIdCorso = async (data) => {
        setLoadingState({ ...loadingState, isLoadingContenutiByIdCorso: true });
        try {
          let response = await CorsiService.findContenutiByIdCorso(data);
          const res = response?.map(contenuto => ({
            ...contenuto,
            percorso_file: contenuto.percorso_file?.startsWith(REACT_APP_REST_DOMAIN) ? 'http://' + contenuto.percorso_file : contenuto.percorso_file
        }));
          return res;
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingContenutiByIdCorso: false });
        }
      }


      const getCorsiByParams = async (params) => {
        setLoadingState({ ...loadingState, isLoadingCorsiByParams: true });
        try {
          let obj;
          let response = await CorsiService.getCorsiByParams(params);
          const res = await response.json();
          const totalRecord = response.headers.get('X-Total-Record');
            obj = {
              data: res,
              count: totalRecord
            }
          return obj
        } catch (err) {
          handleError(err)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiByParams: false });
        }
      }

      const updateStateCorso = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUpdateStateCorso: true });
        try {
          let response = await CorsiService.updateStateCorso(data);
          setModalState(state => ({ 
            ...state,
            showModalUpdateStateCorso: false, 
           }));
          return response;
        } catch (err) {
          handleError(err)
        } finally {
          setLoadingState({ ...loadingState, isLoadingUpdateStateCorso: false });
        }
      }

      
      const addDocumentCorsi = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiAddDocument: true });
        try {
          let response = await CorsiService.addDocumentCorsi(data);
          return response
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiAddDocument: false });
        }
      }

      const deleteDocumentCorsi = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiDeleteDocument: true });
        try {
          let response = await CorsiService.deleteDocumentCorsi(data);
          return response
        } catch (error) {
          handleError(error)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiDeleteDocument: false });
        }
      }

  return {
    loadingStateCorsi: loadingState,
    modalStateCorsi: modalState,
    setModalStateCorsi: setModalState,
    getAllCorsi,
    createCorso,
    addDocumentCorsi,
    deleteDocumentCorsi,
    deleteCorso,
    findCorsiByIdUtente,
    updateStateCorso,
    findCorsoById,
    findContenutiByIdCorso,
    updateCorso,
    getCorsiByParams,
    findDocumentiByIdCorso
  };      
}

export default useCorsi;